import React from 'react'
import { Tooltip } from 'antd'
import { MessageOutlined } from '@ant-design/icons'
import { CommentCellProps } from './interfaces'
import { IconWrapper, CommentContent, CellWrapper } from './styles'

export const CommentCell: React.FC<CommentCellProps> = ({ comment }) => {
  if (!comment || comment.trim() === '') {
    return null
  }

  return (
    <CellWrapper onClick={(e) => e.stopPropagation()}>
      <Tooltip
        title={<CommentContent>{comment}</CommentContent>}
        placement="right"
        trigger="hover"
        overlayStyle={{ maxWidth: '400px' }}
        color="#262626"
      >
        <IconWrapper>
          <MessageOutlined />
        </IconWrapper>
      </Tooltip>
    </CellWrapper>
  )
}

